import Description from "./Description";

export default class Variant {
	id: string;
	name: string;
	baseCost: number;
	cost: number;
	productionTime: number;
	productionDepartment: string;
	image: string;
	cmDown: number;
	cmUp: number;
	byNeedle: boolean;
	descriptions: Array<Description>;
	itemId: string;
	displayOrder: number;

	constructor(variant?: Variant) {
		this.descriptions = new Array<Description>();

		if (variant) {
			this.id = variant.id;
			this.name = variant.name;
			this.baseCost = variant.baseCost;
			this.cost = variant.cost;
			this.productionTime = variant.productionTime;
			this.productionDepartment = variant.productionDepartment;
			this.descriptions = variant.descriptions;
			this.image = variant.image;
			this.cmDown = variant.cmDown;
			this.cmUp = variant.cmUp;
			this.byNeedle = variant.byNeedle;
			this.itemId = variant.itemId;
			this.displayOrder = variant.displayOrder;
		}
	}
}
